export default __webpack_public_path__ + "static/media/anxiety-banner.cb6ddea6.png";